import apiSlice from 'renderer/shared/state/apiSlice';
import {
  CloseNotificationRequest,
  CloseNotificationResponse,
  CloseNotificationResponseSchema,
  CreateNotificationRequest,
  CreateNotificationResponse,
  CreateNotificationResponseSchema,
  DeleteNotificationRequest,
  DeleteNotificationResponse,
  DeleteNotificationResponseSchema,
  EditNotificationRequest,
  EditNotificationResponse,
  EditNotificationResponseSchema,
  GetNotificationRequest,
  GetNotificationResponse,
  GetNotificationResponseSchema,
  ListNotificationsRequest,
  ListNotificationsResponse,
  ListNotificationsResponseSchema,
} from '../schemas/notifications.schemas';

const extendedApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNotificationDetails: builder.query<
      GetNotificationResponse,
      GetNotificationRequest
    >({
      query: (id) => `/notification/${id}`,
      extraOptions: {
        responseSchema: GetNotificationResponseSchema,
      },
      providesTags: ['Notification'],
    }),
    listNotifications: builder.query<
      ListNotificationsResponse,
      ListNotificationsRequest
    >({
      query: () => '/notification',
      extraOptions: {
        responseSchema: ListNotificationsResponseSchema,
      },
      providesTags: ['Notification'],
    }),
    createNotification: builder.mutation<
      CreateNotificationResponse,
      CreateNotificationRequest
    >({
      query: (body) => ({
        url: '/notification',
        body,
        method: 'POST',
      }),
      extraOptions: {
        responseSchema: CreateNotificationResponseSchema,
      },
      invalidatesTags: ['Notification'],
    }),
    updateNotification: builder.mutation<
      EditNotificationResponse,
      EditNotificationRequest
    >({
      query: (body) => ({
        url: `/notification/${body.notificationId}`,
        body,
        method: 'PUT',
      }),
      extraOptions: {
        responseSchema: EditNotificationResponseSchema,
      },
      invalidatesTags: ['Notification'],
    }),
    deleteNotification: builder.mutation<
      DeleteNotificationResponse,
      DeleteNotificationRequest
    >({
      query: (id) => ({
        url: `/notification/${id}`,
        method: 'DELETE',
      }),
      extraOptions: {
        responseSchema: DeleteNotificationResponseSchema,
      },
      invalidatesTags: ['Notification'],
    }),
    closeNotification: builder.mutation<
      CloseNotificationResponse,
      CloseNotificationRequest
    >({
      query: ({ notificationId, userId }) => ({
        url: `/notification/${notificationId}/close/${userId}`,
        method: 'DELETE',
      }),
      extraOptions: {
        responseSchema: CloseNotificationResponseSchema,
      },
      invalidatesTags: ['Notification'],
    }),
  }),
});

export const {
  useGetNotificationDetailsQuery,
  useListNotificationsQuery,
  useCreateNotificationMutation,
  useUpdateNotificationMutation,
  useDeleteNotificationMutation,
  useCloseNotificationMutation,
} = extendedApi;
